export const NEXT = 'saleProcess/NEXT';
export const PREV = 'saleProcess/PREV';
export const CANCEL = 'saleProcess/CANCEL';
